import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SiteDTO } from 'src/app/models/Sites/siteDTO';
import { AppState, sitesStateSitesList } from 'src/app/store/reducers';
import { LinkResult } from '../product-sites-dialog/product-sites-dialog.component';

interface FailedLinkView {
  siteCode: string,
  productCode: string,
  messageCode: string,
}

@Component({
  selector: 'app-failed-link-product-sites-dialog',
  templateUrl: './failed-link-product-sites-dialog.component.html',
  styleUrls: ['./failed-link-product-sites-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FailedLinkProductSitesDialogComponent implements OnInit {
  failedLinkList: FailedLinkView[];
  loadedSites$: Observable<SiteDTO[]>;

  displayedColumns: string[] = [
    'siteCode',
    'message'
  ]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
  ) {
    this.loadedSites$ = this.store.pipe(select(sitesStateSitesList));
  }

  ngOnInit(): void {
    this.initializeState();
  }

  initializeState() {
    const result: LinkResult = this.data?.result;
    if (!result || !Object.keys(result.errors).length) {
      return;
    }

    this.loadedSites$.subscribe((sites) => {
      
      this.failedLinkList = Object.entries(result.errors).map(error => {
        return {
          siteCode: sites.find(site => site.code === error[0]).siteNumber,
          productCode: Object.keys(error[1])[0],
          messageCode: Object.values(error[1])[0][0].code,
        };
        return {
          siteCode: error[0],
          productCode: Object.keys(error[1])[0],
          messageCode: Object.values(error[1])[0][0].code,
        };
      })
    })

  };
}
